import {Component, inject, signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {RouterLink} from '@angular/router';
import {map, tap} from 'rxjs/operators';
import {IackathonGroupComponent} from '../../components/iackathon-group/iackathon-group.component';
import {IackathonSaveAttributes} from '../../models/iackathon-save.attributes';
import {IackathonSavesService} from '../../services/iackathon-saves.service';

@Component({
    selector: 'app-iackathon-group-list-page',
    imports: [
        RouterLink,
        IackathonGroupComponent,
        MatProgressSpinner
    ],
    templateUrl: './iackathon-group-list-page.component.html',
    styleUrl: './iackathon-group-list-page.component.scss',
})
export class IackathonGroupListPageComponent {
    private iackathonSavesService = inject(IackathonSavesService);

    protected readonly isLoading = signal(true);
    protected readonly groupSaves = toSignal(
        this.iackathonSavesService.fetchSaves().pipe(tap(() => this.isLoading.set(false)))
    , {initialValue: []});

}
